import { EyeIcon, EyeOffIcon } from '@heroicons/react/solid'
import { useMemo } from 'react'
import { savedHideSecret } from 'src/storage'
import { Label } from '../../ui/label'

type Props = {
  label: string
  value: string
  type?: 'text' | 'url' | 'secret'
  title?: string
}

export function Kvp(props: Props) {
  const ChildComponent = useMemo(() => {
    switch (props.type) {
      case 'url':
        return <Url value={props.value} />
      case 'secret':
        return <Secret value={props.value} />
      case 'text':
      default:
        return <Text value={props.value} />
    }
  }, [props.type, props.value])

  return (
    <div className="flex flex-col group">
      <Label title={props.title} className="mb-1 group-hover:text-slate-500">
        {props.label}
      </Label>

      {ChildComponent}
    </div>
  )
}

function Text(props: Pick<Props, 'value'>) {
  return (
    <div className="text-base font-normal break-all text-slate-700">
      {props.value}
    </div>
  )
}

function Secret(props: Pick<Props, 'value'>) {
  const [isHidden, setIsHidden] = savedHideSecret.useState(true)

  return (
    <label
      className="flex flex-row items-center flex-1 cursor-pointer"
      onClick={() => setIsHidden((prev) => !prev)}
    >
      <div className="flex-1 text-base font-normal break-all text-slate-700">
        {isHidden ? '••••••••••••' : props.value}
      </div>

      {isHidden ? (
        <EyeIcon className="w-4 h-4 ml-2 text-slate-400" />
      ) : (
        <EyeOffIcon className="w-4 h-4 ml-2 text-slate-400" />
      )}
    </label>
  )
}

function Url(props: Pick<Props, 'value'>) {
  return (
    <a
      href={props.value}
      target="_blank"
      rel="noreferrer"
      className="text-base font-normal break-all cursor-pointer text-slate-700 decoration-dotted underline-offset-4 hover:underline hover:text-theme-500"
    >
      {props.value}
    </a>
  )
}
